import React from "react";
import UserAvatar from "./UserAvatar";
import { useNavigate } from "react-router-dom";

interface UserSnippetProps {
  fullName: string;
  email: string;
  id: number;
}

const UserSnippet = ({ fullName, email, id }: UserSnippetProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-3 p-2">
      <div className="w-10">
        <UserAvatar
          fullName={fullName}
          textSize="text-md"
        />
      </div>
      <div className="flex flex-col">
        <div
          className="font-medium text-gray-900 hover:underline transition-all cursor-pointer"
          onClick={() => navigate(`/admin/users/${id}`)}
        >
          {fullName}
        </div>
        <div className="flex items-center gap-1">
          <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full">
            Mail
          </span>
          <span className="text-gray-500 text-sm">{email}</span>
        </div>
      </div>
    </div>
  );
};

export default UserSnippet;
